import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  loadingToggleAction,
  loginAction,
  signupFailedAction,
} from "../../store/actions/AuthActions";

import rainbow from "../../images/rainbow.gif";
import { post } from "../../services/api";

function Login(props) {
  const [heartActive, setHeartActive] = useState(true);

  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();

  async function onLogin(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };
    if (email === "") {
      errorObj.email = "Email is Required";
      error = true;
    }
    if (password === "") {
      errorObj.password = "Password is Required";
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }
    dispatch(loadingToggleAction(true));
    try{
      const res = await post("/api/auth/check-email", { email, password });
      if(res.status === 200) {
        if(res.data?.isRegistered) {
          dispatch(loginAction(email, password, navigate));
        } else {
          dispatch(signupFailedAction("Email is not registered with us. Please try again with valid email."));
        }
      }
    }catch(e){
      dispatch(signupFailedAction("Something went wrong while login."));
    }
  }
  return (
    <div className="page-wraper">
      <div className="login-account">
        <div className="row h-100">
          <div className="col-lg-6 align-self-start">
            <div
              className="account-info-area"
              style={{ backgroundImage: "url(" + rainbow + ")" }}
            >
              <div className="login-content">
                <p className="sub-title">
                  Log in to your dashboard with your credentials
                </p>
                <h1 className="title">
                TalenTrail
                  {/* The Evolution of <span>TalenTrail</span> */}
                </h1>
                {/* <p className="text">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt
                </p> */}
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-7 col-sm-12 mx-auto align-self-center">
            <div className="login-form">
              <div className="login-head">
                <h3 className="title">Welcome Back</h3>
                <p>Enter your work email address.</p>
              </div>
              <h6 className="login-title">
                <span>Login</span>
              </h6>
              {props.errorMessage && (
                <div className="bg-red-300 text-red border border-red-900 p-1 my-2">
                  {props.errorMessage}
                </div>
              )}
              {props.successMessage && (
                <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                  {props.successMessage}
                </div>
              )}
              <form onSubmit={onLogin}>
                <div className="mb-4">
                  <label className="mb-1 text-dark">Email</label>
                  <input
                    type="email"
                    //placeholder="Enter email ..."
                    className="form-control form-control-lg"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors.email && (
                    <div className="text-danger fs-12">{errors.email}</div>
                  )}
                </div>
                <div className="mb-4">
                  <label className="mb-1 text-dark">Password</label>
                  <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    //placeholder="******"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <i className="fa fa-eye-slash"></i> : <i className="fa fa-eye"></i>}
                  </button>
                  </div>
                  {errors.password && (
                    <div className="text-danger fs-12">{errors.password}</div>
                  )}
                </div>
                <div className="form-row d-flex justify-content-between mt-4 mb-2">
                  <div className="mb-4">
                    <div className="form-check custom-checkbox mb-3">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="customCheckBox1"
                        required=""
                      />
                      <label
                        className="form-check-label"
                        htmlFor="customCheckBox1"
                      >
                        Remember my preference
                      </label>
                    </div>
                  </div>
                </div>
                <div className="text-center mb-4">
                  <button type="submit" className="btn btn-primary btn-block">
                    Sign Me In
                  </button>
                </div>
                {/* <p className="text-center">
                  Not registered ?
                  <Link to={"/page-register"} className="btn-link text-primary">
                    {" "}
                    Register
                  </Link>
                </p> */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};
export default connect(mapStateToProps)(Login);
